import { createRoot } from '@wordpress/element';
import './style.scss';


jQuery('p[class*="scene-"]').visibility({
    once: false,
    offset: 0,
    observeChanges: true,
    initialCheck: true,
    checkOnRefresh: true,
    refreshOnResize: true,
    includeMargin:false,
    continuous: false,
    onTopVisible: function(e) {  
        const re = /(?:scene\-)(?<scene>[0-9]+)/g.exec( this.classList );
        if ( typeof re?.groups?.scene != 'undefined' ) {
            if (+re.groups.scene > 1 ) {
                document.querySelector('.fixed img').classList.add('hidden');
            } else {
                document.querySelector('.fixed img').classList.remove('hidden');
            }
        }  
    },
});

jQuery('.scrolly').visibility({
    once: false,
    offset: 100,
    observeChanges: true,
    initialCheck: true,
    checkOnRefresh: true,
    refreshOnResize: true,
    includeMargin:true,
    continuous: true,
    onUpdate:  e => {
        if (e.onScreen && e.percentagePassed < 0.8) {
            document.documentElement.classList.add('snappy');
        } else {
            document.documentElement.classList.remove('snappy');
        }
    }
});
